import React, { useEffect, useState } from 'react';
import api from "../../utils/axiosInstance";
import AdminSideMenu from '../../components/AdminSideMenu';

const CarrierPendingApproval = () => {
    const [employers, setEmployers] = useState([]);
    const [modal, setModal] = useState({ show: false, title: '', id: null });
    const [viewCarrier, setViewCarrier] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;
    const pageCount = Math.ceil(employers.length / itemsPerPage);

    const paginatedEmployers = employers.slice(
        (currentPage - 1) * itemsPerPage,
        (currentPage - 1) * itemsPerPage + itemsPerPage
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [employers]);

    const fetchPending = async () => {
        try {
            const res = await api.get('/pendingcarriers');
            setEmployers(res.data);
        } catch (err) {
            console.error('Failed to fetch:', err);
        }
    };

    useEffect(() => {
        fetchPending();
    }, []);

    const showModal = (title, id) => {
        setModal({ show: true, title, id });
    };

    const hideModal = () => {
        setModal({ show: false, title: '', id: null });
    };

    const confirmAction = async () => {
        try {
            if (modal.title.includes('Approve')) {
                await api.post(`/pendingcarriers/approve/${modal.id}`);
            } else {
                await api.delete(`/pendingcarriers/${modal.id}`);
            }
            hideModal();
            fetchPending();
        } catch (err) {
            console.error('Action failed:', err);
        }
    };

    return (
        <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
            <AdminSideMenu />
            <div className="w-full md:ml-64 p-4 sm:p-6 lg:p-8">
                <header className="pb-4">
                    <h1 className="text-3xl font-bold text-gray-900">Pending Approval</h1>
                    <p className="text-gray-600">Review and Approve Carriers here</p>
                </header>

                <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                    {employers.length === 0 ? (
                        <div className="col-span-full text-center text-gray-500 text-lg py-12">
                            No records found
                        </div>
                    ) : (
                        paginatedEmployers.map((emp) => (
                            <div
                                key={emp._id}
                                className="bg-white p-6 rounded-xl shadow-sm border border-blue-700 border-l-4 border-l-blue-primary hover:scale-[1.02] hover:shadow-md transition relative"
                            >
                                <button
                                    onClick={() => setViewCarrier(emp)}
                                    className="absolute top-4 right-4 text-gray-600 hover:text-black"
                                    title="View Details"
                                >
                                    <i className="fas fa-eye text-lg"></i>
                                </button>

                                <div className="flex items-center mb-3">
                                    <img
                                        src={emp.companyLogo ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${emp.companyLogo}` : './assets/dummy-icon.jpg'}
                                        alt="Logo"
                                        className="w-12 h-12 rounded-full mr-4 object-cover"
                                    />

                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">{emp.companyName}</h3>

                                    </div>
                                </div>
                                <div className="space-y-1 text-sm text-gray-600">
                                    <p><span className="font-semibold">Contact:</span> {emp.contactName}</p>
                                    <p><span className="font-semibold">Email:</span> {emp.email}</p>
                                    <p><span className="font-semibold">Address:</span> {emp.address}</p>
                                    <p><span className="font-semibold">Zip Code:</span> {emp.zip}</p>
                                    <p><span className="font-semibold">Phone:</span> {emp.phone}</p>
                                    <p>
                                        <span className="font-semibold">Date of Register:</span>{' '}
                                        {emp.createdAt ? new Date(emp.createdAt).toLocaleDateString('en-US') : 'N/A'}
                                    </p>                                    {emp.website && (
                                        <p>
                                            <span className="font-semibold">Website:</span>{' '}
                                            <a href={emp.website} className="text-blue-500 hover:underline" target="_blank" rel="noopener noreferrer">{emp.website}</a>
                                        </p>
                                    )}
                                </div>
                                <div className="mt-4 flex flex-wrap gap-2">
                                    <button
                                        onClick={() => showModal('Approve Carrier', emp._id)}
                                        style={{ backgroundColor: '#888888', color: '#fff' }}
                                        className="inline-block px-4 py-2 rounded font-semibold"
                                    >
                                        Approve
                                    </button>

                                    <button
                                        onClick={() => showModal('Reject Carrier', emp._id)}
                                        className="bg-blue-600 text-white px-4 py-2 rounded font-semibold"
                                    >
                                        Reject
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </section>
                {pageCount > 1 && (
                    <div className="flex justify-center mt-10">
                        <nav className="flex items-center space-x-1 bg-white px-4 py-3 rounded-xl shadow-md">
                            {/* Prev button */}
                            <button
                                onClick={() => setCurrentPage(c => Math.max(1, c - 1))}
                                disabled={currentPage === 1}
                                aria-label="Previous page"
                                className={`w-9 h-9 flex items-center justify-center rounded-full transition-all border text-xl
          ${currentPage === 1
                                        ? 'bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed'
                                        : 'bg-gray-50 text-gray-500 border-gray-300 hover:bg-blue-100 hover:text-blue-700'}
        `}
                            >
                                &lt;
                            </button>
                            {[...Array(pageCount)].map((_, i) => (
                                <button
                                    key={i}
                                    onClick={() => setCurrentPage(i + 1)}
                                    aria-current={currentPage === i + 1 ? 'page' : undefined}
                                    className={`w-9 h-9 rounded-full flex items-center justify-center mx-0.5 text-base transition-all font-semibold border
            ${currentPage === i + 1
                                            ? 'bg-blue-600 text-white shadow border-blue-600'
                                            : 'bg-gray-50 text-gray-900 border-gray-300 hover:bg-blue-100 hover:text-blue-700'}
          `}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            {/* Next button */}
                            <button
                                onClick={() => setCurrentPage(c => Math.min(pageCount, c + 1))}
                                disabled={currentPage === pageCount}
                                aria-label="Next page"
                                className={`w-9 h-9 flex items-center justify-center rounded-full transition-all border text-xl
          ${currentPage === pageCount
                                        ? 'bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed'
                                        : 'bg-gray-50 text-gray-500 border-gray-300 hover:bg-blue-100 hover:text-blue-700'}
        `}
                            >
                                &gt;
                            </button>
                        </nav>
                    </div>
                )}

                {/* Approve/Reject Modal */}
                {modal.show && (
                    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-lg p-8 max-w-sm w-full text-center">
                            <h3 className="text-xl font-bold text-gray-900 mb-6">{modal.title}</h3>
                            <div className="flex justify-center gap-4">
                                <button
                                    onClick={hideModal}
                                    style={{ backgroundColor: '#888888', color: '#fff' }}
                                    className="inline-block px-4 py-2 rounded font-semibold"                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={confirmAction}
                                    className="bg-blue-600 text-white px-5 py-2 rounded font-semibold"
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* View Details Modal */}
                {viewCarrier && (
                    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
                        <div className="bg-white max-w-2xl w-full rounded-xl shadow-lg p-6 relative max-h-[90vh] overflow-y-auto">
                            <button
                                className="absolute top-4 right-4 text-black text-6xl"
                                onClick={() => setViewCarrier(null)}
                            >
                                &times;
                            </button>
                            <h2 className="text-2xl font-bold mb-4">Carrier Details</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                                <p><strong>Company Name:</strong> {viewCarrier.companyName}</p>
                                <p><strong>Equipment Hauled:</strong> {viewCarrier.trailer || 'N/A'}</p>
                                <p><strong>Contact Name:</strong> {viewCarrier.contactName}</p>
                                <p><strong>Job Title:</strong> {viewCarrier.jobTitle || 'N/A'}</p>
                                <p><strong>Email:</strong> {viewCarrier.email}</p>
                                <p><strong>Phone:</strong> {viewCarrier.phone}</p>
                                <p><strong>Address:</strong> {viewCarrier.address}</p>
                                <p><strong>City:</strong> {viewCarrier.city}</p>
                                <p><strong>State:</strong> {viewCarrier.state}</p>
                                <p><strong>ZIP:</strong> {viewCarrier.zip}</p>
                                <p><strong>Website:</strong> {viewCarrier.website || 'N/A'}</p>
                                <p className="md:col-span-2"><strong>Description:</strong> {viewCarrier.companyDesc}</p>
                                {viewCarrier.companyLogo && (
                                    <div className="md:col-span-2 mt-2">
                                        <strong>Company Logo:</strong>
                                        <img
                                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${viewCarrier.companyLogo}`}
                                            alt="Company Logo"
                                            className="w-32 h-32 mt-2 border rounded object-cover"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CarrierPendingApproval;
